import React from 'react';
import './header.css';

function Header() {
  return (
    <header className="hero-section d-flex align-items-center justify-content-center text-center text-white position-relative">
      {/* Dark overlay over background grid */}
      <div className="hero-overlay"></div>

      {/* Hero Content */}
      <div className="container position-relative z-2 pt-5">
        <h5 className="display-6 fw-normal text-uppercase tracking-wider mb-4 font-serif">
          Where Talent Meets Opportunity
        </h5>

        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 mt-4">
          <button className="btn btn-hero btn-coral text-white fw-semibold px-4 py-2 text-uppercase">
            Call Now
          </button>
          <button className="btn btn-hero btn-coral text-white fw-semibold px-4 py-2 text-uppercase">
            Hire Actors 
          </button>
        </div>
      </div>

      {/* Floating Bottom Scroll-to-Top Button */}
      <a href="#home" className="scroll-top-btn position-absolute bottom-0 end-0 m-4 text-white">
        <i className="bi bi-chevron-up-circle-fill fs-2"></i>
      </a>
    </header>
  );
}

export default Header;